(() => {
  const root = document.documentElement;
  const mobile = window.matchMedia('(max-width: 768px)');
  let header;
  let placeholder;
  let headerSection;
  let originAnchor;
  let previousY = window.scrollY;
  let distance = 0;
  let direction = 0;
  let hidden = false;
  let frame = 0;
  let resizeObserver;

  function render(forceVisible = false) {
    frame = 0;
    if (!header || !placeholder || !headerSection) return;
    header.classList.add('drp-mobile-header');
    const y = Math.max(0, Math.min(window.scrollY, Math.max(0, root.scrollHeight - window.innerHeight)));
    // The sticky section moves with the viewport; measure its non-sticky sibling.
    const origin = originAnchor ? originAnchor.getBoundingClientRect().bottom + window.scrollY : 0;
    const height = header.offsetHeight;
    const floating = y > origin;
    const delta = y - previousY;
    const nextDirection = Math.sign(delta);
    if (nextDirection && nextDirection !== direction) {
      distance = 0;
      direction = nextDirection;
    }
    distance += delta;
    const locked = root.matches('.js-drawer-open, .js-modal-open, .drapeur-favorites-open, .drapeur-quick-add-open') ||
      !!header.querySelector(':focus-visible, [aria-expanded="true"], .site-header__search-container.is-active, .site-nav__item--has-dropdown:hover');

    if (forceVisible || locked || y <= origin + height) {
      hidden = false;
      distance = 0;
    } else if (distance >= (mobile.matches ? 24 : 40)) {
      hidden = true;
      distance = 0;
    } else if (distance <= -12) {
      hidden = false;
      distance = 0;
    }

    // CSS sticky owns the top boundary and iOS rubber-band scrolling.
    // JavaScript only controls visibility, never relative/fixed positioning.
    header.classList.toggle('drp-mobile-header--at-top', y <= origin + height);
    headerSection.classList.toggle('drp-scroll-header-section--hidden', floating && hidden);
    header.classList.toggle('drp-mobile-header--floating', floating);
    header.classList.toggle('drp-mobile-header--hidden', floating && hidden);
    root.style.setProperty('--drp-mobile-header-offset', floating && !hidden ? `${height}px` : '0px');
    previousY = y;
  }

  function schedule() {
    if (!frame) frame = window.requestAnimationFrame(() => render());
  }

  function init() {
    const nextHeader = document.getElementById('SiteHeader');
    const nextPlaceholder = document.getElementById('StickyHeaderWrap');
    if (header === nextHeader && placeholder === nextPlaceholder) {
      schedule();
      return;
    }
    if (resizeObserver) resizeObserver.disconnect();
    header = nextHeader;
    placeholder = nextPlaceholder;
    headerSection = header && header.closest('.shopify-section');
    originAnchor = headerSection && headerSection.previousElementSibling;
    if (headerSection) headerSection.classList.add('drp-scroll-header-section');
    previousY = window.scrollY;
    distance = 0;
    direction = 0;
    hidden = false;
    render();
    if (header && placeholder) {
      resizeObserver = new ResizeObserver(schedule);
      resizeObserver.observe(header);
      resizeObserver.observe(placeholder);
    }
  }

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('pageshow', init);
  mobile.addEventListener('change', init);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('collection:reloaded', schedule);
  document.addEventListener('drawerOpen', () => render(true));
  document.addEventListener('predictive-search:open', () => render(true));
  document.addEventListener('focusin', event => {
    if (header && header.contains(event.target)) render(true);
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
